import {itemHandler, isPurchasable, initIngredients} from '../../store/actions/BurgerBuilder';
import {authRedirect} from '../../store/actions/auth';
import Aux from '../../hoc/Aux';
import BuildControls from '../../components/BuildControls/BuildControls';
import Burger from '../../components/Burger/Burger';
import Modal from '../../components/UI/modal/Modal';
import OrderSummary from '../../components/OrderSummay/OrderSummary';
import React, { Component } from 'react';
import Spinner from '../../components/UI/spinner/spinnner';
import axios from '../../axios-orders.js'
import withErrorHandler from '../../hoc/withErrorHandler';
import { connect } from 'react-redux';

class BurgerBuilder extends Component {

    state = {
        ordered: false,
        loading: false,
        ingredientsError: false,
    }


    componentDidMount() {
        this.props.initIngredients();
    }

    showModal = () => {
        if(!this.props.isAuthenticated){
            this.setState({ ordered: true })
            //return true;
        }else{
        this.props.authRedirect('/checkout');
        this.props.history.push('/auth');
        }
    }

    dontShowModal = () => {
        this.setState({ ordered: false })
        return false;
    }

    proceedToCheckout = () => {
        this.props.history.push({
            pathname: '/checkout',
        });

    }


    render() {

        let orderSummary = null;


        let webPage = this.props.ingredientsError ? <h3 style={{textAlign: 'center'}}>Unable to load Ingredients...</h3> : <Spinner align/>;
        if (this.props.ingredients) {
            webPage = (
                <Aux>
					<Burger ingredients={this.props.ingredients} />
					<BuildControls 
                    click={this.props.itemHandler}
                    price={this.props.totalPrice}
					purchasable={this.props.totalPrice > 4}
                    order={this.showModal}
                    isAuth={this.props.isAuthenticated}/>
				</Aux>
            );
            orderSummary = <OrderSummary ingredients={this.props.ingredients}
					price={this.props.totalPrice}
					click={this.dontShowModal}
					proceed={this.proceedToCheckout}
					/>;

        }

        if (this.state.loading) {
            orderSummary = <Spinner />
        }


        return (
            <Aux>
				{this.state.ordered?(
					<Modal show={this.state.ordered} click={this.dontShowModal}>
					  {orderSummary}
					</Modal>): null}
				{webPage}
			</Aux>
        )
    }
}

const mapStateToProps = state => {
    return {
        totalPrice: state.bB.totalPrice,
        ingredients: state.bB.ingredients,
        ingredientsError: state.bB.ingredientsError,
        isAuthenticated: state.auth.auth !== null
    }
}

const mapDispatchToProps = dispatch => {
    return {
        itemHandler: (type, value)   => dispatch(itemHandler(type, value)),
        isPurchasable: (ingredients) => dispatch(isPurchasable()),
        initIngredients:  () => dispatch(initIngredients()),
        authRedirect: (path) => dispatch(authRedirect(path))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(BurgerBuilder, axios));



// WEBPACK FOOTER //
// ./src/containers/BurgerBuilder/BurgerBuilder.jsx